export default "__VITE_ASSET__dmm6BtaJ__"